import { useFormContext, Controller } from "react-hook-form";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, CircularProgress } from "@mui/material";

interface PropsEditarPrescricao {
    open: boolean;
    onClose: () => void;
    isEditing: boolean;
    handleFormSubmit: (data: any) => void;
}

export default function DialogEditarInformacoesComplementares({
                                                         open,
                                                         onClose,
                                                         isEditing,
                                                         handleFormSubmit
                                                     }: PropsEditarPrescricao) {
    const {handleSubmit, control} = useFormContext();

    return (
        <Dialog open={open} fullWidth maxWidth="md" onClose={onClose}>
            <DialogTitle>Editar Informações complementares</DialogTitle>
            <DialogContent>
                <Grid container spacing={2} mt={1}>

                    <Grid size={{xs: 6}}>
                        <Controller
                            name="complemento"
                            control={control}
                            rules={{ required: "Complemento é obrigatório" }}
                            render={({ field, fieldState:{invalid, error} }) => (
                                <TextField
                                    {...field}
                                    label="Complemento"
                                    type="text"
                                    fullWidth
                                    required
                                    error={invalid}
                                    helperText={error?.message}
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={{xs: 6}}>
                        <Controller
                            name="modo_aplicacao"
                            control={control}
                            rules={{ required: "Modo de aplicação é obrigatório" }}
                            render={({ field, fieldState:{invalid, error} }) => (
                                <TextField
                                    {...field}
                                    label="Modo de aplicação"
                                    type="text"
                                    fullWidth
                                    required
                                    error={invalid}
                                    helperText={error?.message}
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={{xs: 6}}>
                        <Controller
                            name="manejo"
                            control={control}
                            rules={{ required: "Manejo é obrigatório" }}
                            render={({ field, fieldState:{invalid, error} }) => (
                                <TextField
                                    {...field}
                                    label="Manejo"
                                    type="text"
                                    fullWidth
                                    required
                                    error={invalid}
                                    helperText={error?.message}
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={{xs: 6}}>
                        <Controller
                            name="epoca_aplicacao"
                            control={control}
                            rules={{ required: "Época de aplicação é obrigatório" }}
                            render={({ field, fieldState:{invalid, error} }) => (
                                <TextField
                                    {...field}
                                    label="Época de aplicação"
                                    type="text"
                                    fullWidth
                                    required
                                    error={invalid}
                                    helperText={error?.message}
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={{xs: 6}}>
                        <Controller
                            name="grupo_quimico"
                            control={control}
                            rules={{ required: "Grupo químico é obrigatório" }}
                            render={({ field, fieldState:{invalid, error} }) => (
                                <TextField
                                    {...field}
                                    label="Grupo químico"
                                    type="text"
                                    fullWidth
                                    required
                                    error={invalid}
                                    helperText={error?.message}
                                />
                            )}
                        />
                    </Grid>

                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onClose} disabled={isEditing}>
                    Cancelar
                </Button>
                <Button
                    type="submit"
                    variant="contained"
                    disabled={isEditing}
                    onClick={handleSubmit(handleFormSubmit)}
                    startIcon={isEditing ? <CircularProgress size={20} color="inherit" /> : null}
                >
                    {isEditing ? "Editar..." : "Editar"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}